const SCRIPT_ID = 'google-maps-places-script';

declare global {
  interface Window {
    google?: {
      maps?: {
        event: {
          clearInstanceListeners: (instance: unknown) => void;
        };
        places: {
          Autocomplete: new (
            input: HTMLInputElement,
            options?: {
              types?: string[];
              componentRestrictions?: { country: string | string[] };
              fields?: string[];
            }
          ) => {
            addListener: (event: string, handler: () => void) => unknown;
            getPlace: () => {
              formatted_address?: string;
              name?: string;
            };
          };
        };
      };
    };
  }
}

export function getGoogleMapsApiKey(): string {
  return (import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '').trim();
}

export function isAddressAutocompleteEnabled(): boolean {
  return getGoogleMapsApiKey().length > 0;
}

let loadPromise: Promise<void> | null = null;

export function loadGooglePlaces(): Promise<void> {
  if (window.google?.maps?.places) {
    return Promise.resolve();
  }
  if (loadPromise) {
    return loadPromise;
  }

  const key = getGoogleMapsApiKey();
  if (!key) {
    return Promise.reject(new Error('Missing Google Maps API key'));
  }

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => {
        loadPromise = null;
        reject(new Error('Failed to load Google Places'));
      }, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Failed to load Google Places'));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
}
